import { render, staticRenderFns } from "./tissue.vue?vue&type=template&id=35b9bd78&"
import script from "./tissue.vue?vue&type=script&lang=js&"
export * from "./tissue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports